import { useSelector } from 'react-redux';
import { useFlag } from 'react-unleash-flags';
import { selectContactlessToken, selectUser } from 'services/Authentication/selectors';
import { AuthUser } from 'services/resources';

export enum FeatureFlags {
  FORCE_VIN = 'force-vin',
  PLANNER_APPOINTMENTS = 'planner-appointments',
  APPOINTMENT_ACTIONS = 'appointment-actions',
  CUSTOMER_CHECKIN = 'customer-checkin',
  CUSTOMER_DOCUMENT_PICTURES = 'customer-document-pictures',
  DASHBOARD_VIEW = 'dashboard-view',
  EDITABLE_ODOMETER_OUT = 'editable-odometer-out',
  OEM_TELEMATICS = 'oem-telematics',
  REQUIRE_CHECKOUT_SIGNATURE = 'require-checkout-signature',
  DATE_RANGE_SELECTOR = 'date-range-selector',
  EXCLUDE_WEEKENDS = 'exclude-weekends',
  VEHICLE_TYPE_ASSIGNMENT = 'vehicle_type_assignment',
}

export default (name: FeatureFlags) => {
  const flag = useFlag(name);
  const user: AuthUser = useSelector(selectUser());
  const guestUserToken = useSelector(selectContactlessToken());

  // eslint-disable-next-line eqeqeq
  if (!flag?.enabled || (user?.id == undefined && guestUserToken == undefined)) {
    // Double equal sign is meaningful here. Equivalent to _.isNil(...)
    return false;
  }

  for (const strategy of flag.strategies) {
    switch (strategy.name) {
      case 'userWithId': {
        // @ts-expect-error TS(2339): Property 'split' does not exist on type 'string | ... Remove this comment to see the full error message
        const userIdsArray = strategy.parameters.userIds.split(/,/);
        if (userIdsArray.includes(String(user.id))) {
          return true;
        }
        break;
      }
      case 'flexibleRollout':
      case 'gradualRolloutUserId':
        // Not Implemented, skip
        break;
      case 'default':
        return flag.enabled;
      default:
        return false;
    }
  }

  return false;
};
